import dayjs from "dayjs";
import "dayjs/locale/it";

export function formatDate(date, format) {
	return dayjs(date).locale("it").format(format);
}

export const addDays = (date, counter) =>
	new Date(date).setDate(new Date(date).getDate() + counter);
